import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import * as AWS from "aws-sdk";
import * as AWSCognito from "amazon-cognito-identity-js";
declare let apigClientFactory: any;

declare var bootbox: any;

import { SharedService } from "../services/shared.service";

export interface Callback {
  cognitoCallback(message: string, result: any): void;
  cognitoCallbackWithCreds(
    message: string,
    result: any,
    creds: any,
    data: any
  ): void;
  googleCallback(creds: any, profile: any);
  googleCallbackWithData(data: any);
  testCallback(result: any, err: any);
}

@Injectable()
export class AwsService {
  token: any;
  googleCreds: any;
  googleProfile: any;
  googleData: any;
  userData: any;

  /*********** RESOURCE IDENTIFIERS ************/

  prodPoolData = {
    UserPoolId: "eu-central-1_Ywz6bhigw",
    ClientId: "1s0n02np2gtpdo4135qhdu2n3m",
  };

  region: string = "eu-central-1"; //Region Matching CognitoUserPool region

  /*********************************************/

  constructor(private _http: HttpClient, private sharedService: SharedService) {
    // Transitional backend migration: QA (like prod) authenticates against the
    // legacy pool eu-central-1_Ywz6bhigw - the default prodPoolData above - so
    // existing clients work unchanged against the new-account backend. The
    // new-account QA pool (ZThMxoioD) stays dormant until the client cutover.

    AWS.config.update({
      region: this.region,
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: "",
      }),
    });

    AWS.config.region = this.region;
  }

  refreshTokens(user: any, refreshToken: any, refreshCallback: any) {
    user.refreshSession(refreshToken, (err, session) => {
      //console.log(session);
      //console.log(err);
      refreshCallback(err, session);
    });
  }

  signOutUser(cognitoUser: any, callback) {
    cognitoUser.globalSignOut({
      onSuccess: function (result) {
        console.log(result);
        callback(result);
      },
      onFailure: function (err) {
        console.log(err);
        callback(err);
      },
    });
  }

  authenticateUserPool(user, password, authCallback) {
    let authenticationData = {
      Username: user,
      Password: password,
    };
    let authenticationDetails = new AWSCognito.AuthenticationDetails(
      authenticationData
    );

    let userPool = new AWSCognito.CognitoUserPool(this.prodPoolData);

    let userData = {
      Username: user,
      Pool: userPool,
    };

    let cognitoUser = new AWSCognito.CognitoUser(userData);

    const aws = this;

    (cognitoUser as any).authenticateUser(authenticationDetails, {
      onSuccess: function (result) {
        console.log("onSuccess");
        let cognitoGetUser = userPool.getCurrentUser();
        if (cognitoGetUser != null) {
          cognitoGetUser.getSession(function (err, result) {
            if (result) {
              console.log("Authenticated to Cognito User Pools!");
            }
          });
        }

        console.log(this);
        authCallback(null, result, cognitoGetUser);
      },

      onFailure: function (err) {
        console.log("onFailure");
        console.log(err);
        authCallback(err, null);
      },

      mfaSetup: function (challengeName, challengeParameters) {
        console.log("mfaSetup");
        (cognitoUser as any).associateSoftwareToken(this);
      },



      selectMFAType: function (challengeName, challengeParameters) {
        console.log("selectMFAType");
        var mfaType = "SOFTWARE_TOKEN_MFA"; // prompt("Please select the MFA method.", "");
        cognitoUser.sendMFASelectionAnswer(mfaType, this);
      },

      totpRequired: function (secretCode) {
        console.log("totpRequired");
        console.log(authenticationDetails.getValidationData());
        aws.sharedService.emitPopupchReceivedEvent({
          /*יש להקליד קוד חד-פעמי לזיהוי:*/
          title: "translate.alert.fillAuthCode",
          subTitle: "translate.validation.putCodeHere",
          form: [
            {
              label: "translate.validation.putCodeHere",
              cssClass: "input-sent-code",
            },
          ],

          approve: (el: HTMLElement) => {
            let newPass: string;
            const popupField: HTMLInputElement =
              el.querySelector(".input-sent-code");
            if (popupField) {
              newPass = popupField.value;
              cognitoUser.sendMFACode(newPass, this, "SOFTWARE_TOKEN_MFA");
            } else {
              aws.sharedService.alertError({
                message: "Flow issue in totpRequired",
              });
            }
          },
        });
      },

      iscsEnterFirstTokenCode: function () {
        console.log("iscsEnterFirstTokenCode");

        aws.sharedService.emitPopupchReceivedEvent({});

        aws.sharedService.emitPopupchReceivedEvent({
          /* יש להקליד קוד חד-פעמי לזיהוי: */
          title: "translate.alert.fillAuthCode",
          subTitle: "translate.validation.putCodeHere",
          form: [
            {
              label: "translate.validation.putCodeHere",
              cssClass: "input-sent-code",
            },
          ],
          keep: true,
          onload: (el: HTMLElement) => {
            const qr_code_holder = el.querySelector(".qr_code_holder");
            console.log(qr_code_holder);
            if (qr_code_holder) {
              qr_code_holder.parentNode.removeChild(qr_code_holder);
            }
          },
          approve: (el: HTMLElement) => {
            let newPass: string;
            const popupField: HTMLInputElement =
              el.querySelector(".input-sent-code");
            if (popupField) {
              newPass = popupField.value;
              cognitoUser.verifySoftwareToken(newPass, "My TOTP device", this);
              aws.sharedService.emitPopupchReceivedEvent({});
            } else {
              aws.sharedService.alertError({
                message: "Flow issue in iscsEnterFirstTokenCode",
              });
            }
          },
        });
      },

      newPasswordRequired: function (userAttributes, requiredAttributes) {
        console.log("newPasswordRequired");
        console.log(userAttributes);

        userAttributes.email_verified = undefined;
        userAttributes.phone_number_verified = undefined;

        aws.sharedService.emitPopupchReceivedEvent({
          title: "translate.alert.choosePassword",
          form: [
            {
              label: "translate.alert.choosePassword", // "יש לבחור סיסמא קבועה שתשמש אותך להתחברות"//
              cssClass: "input-sent-code",
            },
          ],

          approve: (el: HTMLElement) => {
            let newPass: string;
            const popupField: HTMLInputElement =
              el.querySelector(".input-sent-code");
            if (popupField) {
              newPass = popupField.value;
              cognitoUser.completeNewPasswordChallenge(
                newPass,
                //userAttributes,
                [],
                this
              );
            } else {
              aws.sharedService.alertError({
                message: "Flow issue in newPasswordRequired",
              });
            }
          },
        });
      },

      mfaRequired: function (codeDeliveryDetails) {
        console.log("mfaRequired");
        aws.sharedService.emitPopupchReceivedEvent({
          title: "translate.alert.inputSMSIdCode",
          form: [
            {
              label: "translate.alert.inputSMSIdCode",
              cssClass: "input-sent-code",
            },
          ],
          keep: true,
          approve: (el: HTMLElement) => {
            let verificationCode: string;
            const popupField: HTMLInputElement =
              el.querySelector(".input-sent-code");
            if (popupField) verificationCode = popupField.value;
            console.log(verificationCode);

            if (verificationCode) {
              cognitoUser.sendMFACode(verificationCode, {
                onSuccess: function (result) {
                  // User authentication was successful
                  console.log("result", result);
                  let cognitoGetUser = userPool.getCurrentUser();
                  authCallback(null, result, cognitoGetUser);
                },

                onFailure: function (err) {
                  // User authentication was not successful
                  console.log("err", err);
                  authCallback(err, null);
                },
              });
            } else {
              authCallback("EMPTY_TOKEN", null);
            }

            aws.sharedService.emitPopupchReceivedEvent({});
          },
        });
      },
    });
  }

  forgotPassword(username: string, callback: any) {
    let authenticationData = {
      Username: username,
      Password: "",
    };
    let authenticationDetails = new AWSCognito.AuthenticationDetails(
      authenticationData
    );

    let userPool = new AWSCognito.CognitoUserPool(this.prodPoolData);

    let userData = {
      Username: username,
      Pool: userPool,
    };

    let cognitoUser = new AWSCognito.CognitoUser(userData);

    const aws = this;

    console.log("forgotPassword");
    console.log(cognitoUser);

    cognitoUser.forgotPassword({
      onSuccess: (result) => {
        console.log("call result: ");
        console.log(result);
        callback("SUCCESS", result, cognitoUser);
      },
      onFailure: function (err) {
        console.log(err);
        callback("ERROR", err, cognitoUser);
      },
      inputVerificationCode() {
        aws.sharedService.emitPopupchReceivedEvent({
          //"יש להזין קוד אימות שנשלח אליך לכתובת המייל:"
          title: "translate.alert.inputEmailIdCodeTitle",
          subTitle: "translate.alert.inputEmailIdCode",
          form: [
            {
              label: "translate.alert.inputEmailIdCode",
              cssClass: "input-sent-code",
            },
          ],
          keep: true,
          approve: (el: HTMLElement) => {
            let token: string;
            const popupField: HTMLInputElement =
              el.querySelector(".input-sent-code");
            if (popupField) token = popupField.value;
            console.log(token);
            if (token) {
              aws.sharedService.emitPopupchReceivedEvent({
                title: "translate.alert.choosePassword",
                form: [
                  {
                    label: "translate.alert.inputEmailIdCode",
                    cssClass: "input-sent-code",
                  },
                ],
                keep: true,
                approve: (el: HTMLElement) => {
                  let newPass: string;
                  const popupField: HTMLInputElement =
                    el.querySelector(".input-sent-code");
                  if (popupField) newPass = popupField.value;
                  aws.sharedService.capturedUserPassword = newPass;
                  cognitoUser.confirmPassword(token, newPass, this);
                },
              });
            }
          },
        });
      },
    });
  }

  private _serverError(err: any) {
    console.log("sever error:", JSON.stringify(err)); // debug
    if (err.status === 0) {
      throw err["error"] || "UNAUTHORIZED!!!";
    }
    if (err instanceof Response) {
      throw err["error"] || "Backend Server Error";
    }
  }

  retrieveUserSession(callback) {
    let userPool = new AWSCognito.CognitoUserPool(this.prodPoolData);
    var cognitoUser = userPool.getCurrentUser();

    if (cognitoUser != null) {
      cognitoUser.getSession(function (err, session) {
        if (err) {
          //alert(err.message || JSON.stringify(err));
          console.log(err);
          callback(false, cognitoUser);
          return;
        }
        callback(session.isValid(), cognitoUser);
      });
    } else {
      callback(false, null);
    }
  }
}
